import type { SVGProps } from "react";

const AILogo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9441_123514)">
        <path
          d="M5.87621 14.534C4.38107 10.0195 5.08981 10.7185 0.575243 9.23307C-0.191748 8.97093 -0.191748 8.39812 0.575243 8.13598C5.08981 6.64083 4.39078 7.34957 5.87621 2.83501C6.13835 2.06802 6.71117 2.06802 6.9733 2.83501C8.46845 7.34957 7.75971 6.65054 12.2743 8.13598C13.0413 8.39812 13.0413 8.97093 12.2743 9.23307C7.75971 10.7282 8.45874 10.0195 6.9733 14.534C6.71117 15.301 6.13835 15.301 5.87621 14.534Z"
          fill="#EA1B4B"
        />
        <path
          d="M12.5908 5.73789C11.8918 3.63109 12.2219 3.95148 10.1054 3.25245C9.74613 3.13594 9.74613 2.8641 10.1054 2.73789C12.2122 2.03886 11.8918 2.36895 12.5908 0.25245C12.7073 -0.106774 12.9791 -0.106774 13.1054 0.25245C13.8044 2.35925 13.4743 2.03886 15.5908 2.73789C15.95 2.85439 15.95 3.12624 15.5908 3.25245C13.484 3.95148 13.8044 3.62138 13.1054 5.73789C12.9889 6.09711 12.717 6.09711 12.5908 5.73789Z"
          fill="#EA1B4B"
        />
        <path
          d="M13.6471 15.3204C13.1422 13.7961 13.3849 14.0388 11.8607 13.5339C11.5985 13.4466 11.5985 13.2524 11.8607 13.165C13.3849 12.6602 13.1422 12.9029 13.6471 11.3786C13.7345 11.1165 13.9286 11.1165 14.016 11.3786C14.5209 12.9029 14.2781 12.6602 15.8024 13.165C16.0645 13.2524 16.0645 13.4466 15.8024 13.5339C14.2781 14.0388 14.5209 13.7961 14.016 15.3204C13.9286 15.5825 13.7345 15.5825 13.6471 15.3204Z"
          fill="#EA1B4B"
        />
      </g>
      <defs>
        <clipPath id="clip0_9441_123514">
          <rect
            width="16"
            height="15.5146"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AILogo;
